import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../shared/services/auth.service";
import {User} from "../shared/interfaces";
import {Subscription} from "rxjs";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {MaterialService} from "../shared/classes/material.service";
import {NbToastrService, NbGlobalPosition } from '@nebular/theme';
import {   NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit, OnDestroy {

  form: FormGroup
  aSub:Subscription

  constructor(
    public authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: NbToastrService,
    private themeService: NbThemeService


  ) { 

    if(this.authService.isAuthenticated()){
      this.router.navigate(['/overview'])
      return
    }

    this.themeService.changeTheme(localStorage.getItem('theme') || 'default')

  }

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      password: new FormControl(null, [Validators.required, Validators.minLength(6)])
    })

    this.route.queryParams.subscribe((params:Params)=>{
      if(params['registered']){
        //Теперь вы можете зайти в систему используя свои данные
        this.toastrService.show('','Тепер ви можете зайти в систему використовуючи свої дані',{
          status: 'success',
	position: <NbGlobalPosition>'bottom-right'
        })
      }else if(params['accessDenied']){

        this.toastrService.show('','Необхідно авторизуватися',{
          status: 'warning',
	position: <NbGlobalPosition>'bottom-right'
        })
   
      }else if(params['sessionFiled']){
 
        this.toastrService.show('','Ви не авторизовані або час сесії минув',{
          status: 'warning',
	position: <NbGlobalPosition>'bottom-right'
        })
      }
   
    })
  }

  ngOnDestroy(){
    if(this.aSub){
      this.aSub.unsubscribe()
    }
  }

  submit() {
    if(this.form.invalid){
      return
    }

    const user:User = this.form.value;

    this.form.disable()
    this.aSub = this.authService.login(user).subscribe((data: any)=>{
        this.router.navigate(['/overview'])
    },error => {
      this.form.enable()

    //  console.log(error)
     //  MaterialService.toast(error.error ? error.error.message : error.message)

 this.toastrService.show('',error.error ? error.error.message : error.message,{
          status: 'warning',
	position: <NbGlobalPosition>'bottom-right'
        })

    })


  }




}
